import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CoreConfigService } from '@core/services/config.service';

@Component({
  selector: 'home-layout',
  templateUrl: './home-layout.component.html',
  styleUrls: ['./home-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HomeLayoutComponent implements OnInit, OnDestroy {
  coreConfig: any;
  navbarPinned = true;

  private _unsubscribeAll: Subject<any> = new Subject();

  constructor(private _coreConfigService: CoreConfigService) {}

  onPinToggle(): void {
    this.navbarPinned = !this.navbarPinned;
    localStorage.setItem('navbarPinned', String(this.navbarPinned));
  }

  ngOnInit(): void {
    this.navbarPinned = localStorage.getItem('navbarPinned') !== 'false';

    this._coreConfigService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(config => { this.coreConfig = config; });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
